<template>
    <v-main>
        <div class="content">
            <dashboard-core-app-bar/>
            <router-view/>
        </div>
        <Footer/>
    </v-main>
</template>

<script>
    import DashboardCoreAppBar from "./AppBar";
    import Footer from "./Footer";
    export default {
        name: "DashboardCoreView",
        components: {Footer, DashboardCoreAppBar}
    }
</script>